import { useAuth } from './useAuth'

/**
 * True para usuários que não devem editar/criar/deletar processos, documentos
 * e demais entidades operacionais.
 *
 * Cobre:
 *   - Visualizador interno (estagiário/audit)
 *   - Qualquer usuário externo (cliente)
 *
 * Espelha o gate equivalente do backend (`ability.factory.ts`):
 * `!capsHas(caps, 'can_edit_own_records')`. Tipo de cliente e Visualizador não
 * têm `can_edit_own_records`.
 *
 * Permissões adicionais para subset de externos (export, update priority_level)
 * NÃO afetam read-only — vêm via hasCap individualmente.
 */
export const useIsReadOnlyUser = (): boolean => {
  const { hasCap } = useAuth()
  return !hasCap('can_edit_own_records')
}
